<template>
    <section class="page settings" v-if="user">
        <div class="settings-body">
            <div class="settings-item">
                <h3>Введите новый пароль</h3>
                <form class="settings-form" @submit.prevent="changePassword">
                    <input class="input" type="password" v-model.trim="password_new" :class="{invalid: ($v.password_new.$dirty && $v.password_new.required) || ($v.password_new.$dirty && $v.password_new.minLength)}" required placeholder="Введите новый пароль">
                    <!-- <input class="input" type="password" v-model.trim="password_rep" :class="{invalid: !repeatValid}" required placeholder="Повторите новый пароль"> -->
                    <input type="submit" class="button" value="Сбросить пароль">
                </form>
            </div>
            </div>
    </section>
</template>

<script>
import {required, minLength} from 'vuelidate/lib/validators'

export default {
  name: 'Settings',
  data: () => {
      return {
          user: true,
          password_new: null,
          password_rep: null,
          pass_wrong: false
      }
  },
  validations: {
        password_new: {required, minLength: minLength(6)}
    },
  computed: {
    repeatValid() {
        return this.password_new === this.password_rep
    }
  },
  methods: {
      async changePassword() {
        if (this.$v.$invalid){
            this.$v.$touch()    
            return
        } else {
            const formData = {
                remind: this.user,
                password_new: this.password_new,
            };
            this.$axios.post(`/api/auth/newpassword`, formData)
            .then(() => {
                this.$store.dispatch('addNotification', {message: 'Пароль был успешно сброшен!'})
                this.$router.push('/login')
            })
            .catch((e) => {
                this.$store.dispatch('addError', {message: e.response.data})
            });
        }
      }
  },
  created() {
        document.title = this.$route.meta.title;
        let hash = this.$route.params.hash;
        if (hash) {
            
            this.$axios.post(`/api/auth/haslinkpass`, {hash})
            .then(response => {
                response.data.user ? this.user = response.data : this.$router.push('/404')
            })
            .catch(() => {
                this.$router.push('/404')
            });
        } else {
            this.$router.push('/404')
        }
        
    }
}

</script>
<style lang="stylus">
    .settings
        padding 40px 30px
        display flex
        flex-direction column
        
        &-body
            margin-top 30px

        &-item
            width 100%
            padding 30px 0
            border-top 1px solid #f0f0f0
            border-bottom 1px solid #f0f0f0
            h3
                font-weight 500

        &-form
            width 100%
            max-width 500px
            margin-top 20px
            display flex
            flex-direction column
            align-items flex-start
            input
                margin 5px 0
                width 100%
                &.button
                    border-color #2d2c3a
                    background-color #2d2c3a
                    color white
                    width auto
</style>